<template>
  <div id="app" safe-area-inset-top safe-area-inset-bottom>
    <router-view />
  </div>
</template>

<script>
import VConsole from 'vconsole';
import { getConfig } from './utils'

export default {
  mounted() {
    if(process.env.VUE_APP_ENV !== 'prod'){
      new VConsole();
    }
    getConfig()
  }
}
</script>

<style lang="scss">
// @import './assets/style/color-tc.scss';
*{
  touch-action: auto;
}

html,
body,
#app {
  font-size: 28px;
  height: 100%;
  font-family: 'PingFangSC-Regular', 'PingFang SC' !important;
  user-select: none;
  overflow:auto;
}

*::-webkit-input-placeholder {
  font-family: 'PingFangSC-Regular', 'PingFang SC' !important;
  font-size: 24px;
}
*:-moz-placeholder {
  font-family: 'PingFangSC-Regular', 'PingFang SC' !important;
  font-size: 24px;
}
*::-moz-placeholder {
  font-family: 'PingFangSC-Regular', 'PingFang SC' !important;
  font-size: 24px;
}
*:-ms-input-placeholder {
  font-family: 'PingFangSC-Regular', 'PingFang SC' !important;
  font-size: 24px;
}
.van-overlay{
  background: rgba(0,0,0,0.55);
}
*::-webkit-scrollbar {
  width: 1px; /* 设置滚动条的宽度 */
}
 
*::-webkit-scrollbar-track {
  background-color: #f5f6f7; /* 设置滚动条的背景色 */
}
</style>
